import type { Styles } from 'common/types';

export const styles: Styles = {
  stickyContainer: {
    position: 'sticky',
    /**
     * The -50px value is used to offset the 50px padding-top defined in
     * the main content container (.content class in Layout.module.scss).
     * This ensures the sticky product selector aligns with the very top of the
     * browser viewport instead of stopping at the padding boundary.
     */
    top: '-50px',

    zIndex: 10,
    backgroundColor: 'rgba(250, 250, 250, 0.95)',
    backdropFilter: 'blur(8px)',
    borderBottom: '1px solid',
    borderColor: 'divider',
    pt: 0.5,
    pb: 1.5,
  },
  divider: {
    mb: 1.5,
  },
  dividerText: {
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontWeight: 600,
  },
  selectorWrapper: {
    display: 'flex',
    gap: 2,
    overflowX: 'auto',
    pb: 1,
    '&::-webkit-scrollbar': { height: '6px' },
    '&::-webkit-scrollbar-track': { background: 'transparent', borderRadius: '4px' },
    '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: '4px' },
  },
  selectorItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    minWidth: '220px',
    maxWidth: '220px',
    p: 1,
    pr: 2,
    borderRadius: '12px',
    border: '2px solid',
    borderColor: 'divider',
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    userSelect: 'none',
    '&:hover': {
      borderColor: 'primary.light',
      backgroundColor: '#f8fafc',
    },
  },
  selectorItemActive: {
    borderColor: 'primary.main',
    backgroundColor: 'primary.50',
    boxShadow: '0 4px 12px rgba(0, 118, 255, 0.1)',
  },
  selectorImage: {
    width: 48,
    height: 48,
    objectFit: 'contain',
    borderRadius: '8px',
    backgroundColor: '#fff',
    border: '1px solid',
    borderColor: 'divider',
  },
  selectorText: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    fontSize: '0.8rem',
    fontWeight: 500,
    lineHeight: 1.3,
  },
  stickerText: {
    display: 'block',
    mb: 0.5,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};
